import { isNil } from 'vdlib';

import {
  NOTIFICATIONS_DROPDOWN_NAME,
  USER_PROFILE_DROPDOWN_NAME,
  LANGUAGES_DROPDOWN_NAME,
} from 'lib/Constants';
import { APP_ACTION_TYPES } from '../app/App.actions';
import { setLocale } from 'react-redux-i18n';
import Store, { history } from '../Store';

export const defaultState = {
  loading: true,
  error: null,
  lang: null,
  authenticationError: '',
  initialLoadingComplete: false,
  lookups: null,
  user: null,
  userParty: null,

  languagesDropdownOpen: false,
  notificationsDropdownOpen: false,
  userProfileDropdownOpen: false,
  menuDropdownOpen: false,

  alert: null,
};

const app = (state = defaultState, action) => {
  switch (action.type) {
    case APP_ACTION_TYPES.LOGIN:
      return Object.assign({}, state, { loading: true });
    case APP_ACTION_TYPES.LOGIN_SUCCESS:
      return state;
    case APP_ACTION_TYPES.LOGIN_FAIL:
      return Object.assign({}, state, {
        loading: false,
        authenticationError: 'Λάθος όνομα χρήστη ή κωδικός.',
      }); //I.t(WRONG_USERNAME_OR_PASSWORD)

    case APP_ACTION_TYPES.CHANGE_PASSWORD:
      return Object.assign({}, state, { loading: true });
    case APP_ACTION_TYPES.CHANGE_PASSWORD_SUCCESS:
      setTimeout(() => history.push({ pathname: '/' }));
      return Object.assign({}, state, { loading: false });
    case APP_ACTION_TYPES.CHANGE_PASSWORD_FAIL:
      return Object.assign({}, state, { loading: false, error: action.error });

    case APP_ACTION_TYPES.RESET_PASSWORD:
      return Object.assign({}, state, { loading: true });
    case APP_ACTION_TYPES.RESET_PASSWORD_SUCCESS:
      setTimeout(() => history.push({ pathname: '/all-parties' }));
      return Object.assign({}, state, { loading: false });
    case APP_ACTION_TYPES.RESET_PASSWORD_FAIL:
      return Object.assign({}, state, { loading: false, error: action.error });

    case APP_ACTION_TYPES.INITIAL_DATA_FETCH:
      return state;
    case APP_ACTION_TYPES.INITIAL_DATA_FETCH_SUCCESS:
      if (
        isNil(action.payload) ||
        isNil(action.payload.UserInfo) ||
        isNil(action.payload.UserInfo.Id)
      )
        return Object.assign({}, state, {
          initialLoadingComplete: true,
          loading: false,
        });

      let currentLang = Store.getState().i18n.locale;
      if (currentLang !== action.payload.Lang)
        setTimeout(() => Store.dispatch(setLocale(action.payload.Lang)));

      return Object.assign({}, state, {
        initialLoadingComplete: true,
        loading: false,
        user: action.payload.UserInfo,
        userParty: action.payload.UserParty,
        lookups: {
          auctionStatuses: action.payload.Lookups.AuctionStatuses || null,
          bidStatuses: action.payload.Lookups.BidStatuses || null,
          countries: action.payload.Lookups.Countries || null, //.map(f => Object.assign(f, { ID: f.ID, Description: I.t(f.Description) })) || null,
          fuelTypes: action.payload.Lookups.FuelTypes || null,
          vehicleTypes: action.payload.Lookups.VehicleTypes || null,
          wheelDrives: action.payload.Lookups.WheelDrives || null,
          gearBoxes: action.payload.Lookups.GearBoxes || null,
          partTypes: action.payload.Lookups.PartTypes || null,
          partyTypes: action.payload.Lookups.PartyTypes || null,
          regions: action.payload.Lookups.Regions || null, //.map(f => Object.assign(f, { ID: f.ID, Description: I.t(f.Description) })) || null,
          taxOffices: action.payload.Lookups.TaxOffices || null,
          insurances: action.payload.Lookups.Insurances || null,
          experts: action.payload.Lookups.Experts || null,
          bidFileTypes: action.payload.Lookups.BidFileTypes || null,
          imitationPartCategories:
            action.payload.Lookups.ImitationPartCategories || null, //.map(f => Object.assign(f, { ID: f.ID, Description: I.t(f.Description) })) || null,
          usedConditionTypes: action.payload.Lookups.UsedConditionTypes || null, //.map(f => Object.assign(f, { ID: f.ID, Description: I.t(f.Description) })) || null,
          applications: action.payload.Lookups.Applications || null, //.map(f => Object.assign(f, { ID: f.ID, Description: I.t(f.Description) })) || null,
          memberships: action.payload.Lookups.Memberships || null, //.map(f => Object.assign(f, { ID: f.ID, Description: I.t(f.Description) })) || null,
          cancellationReasons:
            action.payload.Lookups.CancellationReasons || null, //.map(f => Object.assign(f, { ID: f.ID, Description: I.t(f.Description) })) || null,
          gtEstimationStatuses:
            action.payload.Lookups.GTEstimationsStatuses || null,
        },
      });
    case APP_ACTION_TYPES.INITIAL_DATA_FETCH_FAIL:
      return {
        ...state,
        authenticating: false,
        error: action.error,
        initialLoadingComplete: true,
        loading: false,
        user: null,
      };
    case APP_ACTION_TYPES.LOGOUT:
      return Object.assign({}, state, { user: null });
    case APP_ACTION_TYPES.TOGGLE_HEADER_DROPDOWN:
      let useForceValue = typeof action.payload.forceValue === 'boolean';
      var obj =
        action.payload.dropdown === USER_PROFILE_DROPDOWN_NAME
          ? {
              userProfileDropdownOpen: useForceValue
                ? action.payload.forceValue
                : !state.userProfileDropdownOpen,
            }
          : action.payload.dropdown === NOTIFICATIONS_DROPDOWN_NAME
          ? {
              notificationsDropdownOpen: useForceValue
                ? action.payload.forceValue
                : !state.notificationsDropdownOpen,
            }
          : action.payload.dropdown === LANGUAGES_DROPDOWN_NAME
          ? {
              languagesDropdownOpen: useForceValue
                ? action.payload.forceValue
                : !state.languagesDropdownOpen,
            }
          : {};
      return Object.assign({}, state, obj);
    case APP_ACTION_TYPES.TOGGLE_HEADER_MENU:
      return Object.assign({}, state, {
        menuDropdownOpen:
          typeof action.payload.forceValue === 'boolean'
            ? action.payload.forceValue
            : !state.menuDropdownOpen,
      });
    case APP_ACTION_TYPES.SHOW_ALERT:
      return Object.assign({}, state, { alert: action.payload });
    case APP_ACTION_TYPES.HIDE_ALERT:
      return Object.assign({}, state, { alert: null });

    default:
      return state;
  }
};

export default app;
